import { Attendee } from '@/types';
import { Typography } from '@eventbrite/marmalade';
import QRCode from 'react-qr-code';
import styles from './TicketAdmission.module.scss';

interface AttendeeComponentProps {
  attendee: Attendee;
  index: number;
  noOfTickets: number;
}

export const TicketAdmission: React.FC<AttendeeComponentProps> = (props) => {
  const { attendee, index, noOfTickets } = props;
  const formattedAttendee = attendee;
  return (
    <div className={styles.ticket_details_block}>
      <div className={styles.admission_div}>
        <Typography variant="body-lg-bold">General Admission</Typography>
        <Typography variant="body-md" className={styles.ticket_count}>
          Ticket {index + 1}/{noOfTickets}
        </Typography>
      </div>
      <div className={styles.ticket_outer_wrapper}>
        <div className={styles.ticket_inner_wrapper}>
          <div className={styles.user_info}>
            <Typography variant="body-md">First Name</Typography>
            <Typography variant="body-md-bold" color={'black'}>
              {formattedAttendee.firstName}
            </Typography>
          </div>
          <div className={styles.user_info}>
            <Typography variant="body-md">Last Name</Typography>
            <Typography variant="body-md-bold">{formattedAttendee.lastName}</Typography>
          </div>
          <div className={styles.user_info}>
            <Typography variant="body-md">Email</Typography>
            <Typography variant="body-md-bold" color={'black'}>
              {formattedAttendee.email}
            </Typography>
          </div>
        </div>
        <div className={styles.qr_code}>
          <QRCode value={formattedAttendee.barcode.barcode} size={200} level={'H'} />
        </div>
      </div>
    </div>
  );
};
